<template>
  <div class="noenterprise">
    <div class="header">
      <enterprise-header></enterprise-header>
    </div>
    <div class="content">
      <div class="main">
        <div style="width:1280px;height:828px;background:#ffffffcf;margin:17px auto;margin-bottom:0;border-radius: 4px">
          <div class="validationsuccee" style="padding-top:90px">
            <div style="text-align: center;padding-top:105px">
              <img v-if="showtype=='2'||showtype=='4'" :src="jinzhifangwen" alt />
              <img v-else :src="yanzheng" alt />
            </div>
            <div style="margin-top:38px;text-align: center;">
              <div v-if="showtype=='1'" style="margin:0 auto;font-size:22px;color:var(--key-color)">
                企业 【 {{ name }} 】 创建成功，待审核通过后即可管理该企业。请耐心等待。
              </div>
              <div v-if="showtype=='2'" style="margin:0 auto;font-size:22px;color:var(--key-color)">
                您已被企业【{{ name }}】
                <span style="color:red">禁用</span>
              </div>
              <div v-if="showtype=='3'" style="margin:0 auto;font-size:22px;color:var(--key-color)">
                您已发送加入企业 【 {{ name }} 】 申请至负责人，待审批通过之后即可成功加入企业。请耐心等待。
              </div>
              <div v-if="showtype=='4'" style="margin:0 auto;font-size:22px;color:var(--key-color)">
                您的企业【{{ name }}】被
                <span style="color:red">禁用</span>
              </div>
            </div>
            <p v-if="showBtn && (showtype=='2'||showtype=='4')" style="margin-top: 20px;text-align: center;">
              <el-button type="primary" size="small" @click="newjoin">创建新企业</el-button>
            </p>
            <p v-else-if="showBtn" style="margin-top: 20px;text-align: center;">
              您还可以选择
              <span style="color:var(--theme-color);font-size:14px;cursor: pointer;" @click="join">创建新企业</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EnterpriseHeader from "./components/userEnterHeader";
export default {
  components: {
    EnterpriseHeader
  },
  data() {
    return {
      yanzheng: require("@/CommonDP/assets/enterprise/验证成功.png"),
      jinzhifangwen: require("@/CommonDP/assets/enterprise/禁止访问.png"),
      showtype: "", // 1 审核中创建的 2 我被企业禁用 3审核中加入的 4企业被禁用
      name: "",
      showBtn: false
    };
  },
  created() {
    this.showtype = this.$route.query.showtype;
    this.showBtn = this.$route.query.showBtn;
    this.name = this.$route.query.name;
  },
  methods: {
    join() {
      const { href } = this.$router.resolve({ path: "/enterprisepage", query: { pagetype: "1" }});
      window.open(href, "_blank");
    },
    newjoin() {
      const { href } = this.$router.resolve({ path: "/enterprisepage", query: { pagetype: "1" }});
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.noenterprise {
  min-width: 1270px;
  width: 100%;
  min-height: 937px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 68px;
    line-height: 68px;
    overflow: hidden;
    position: absolute;
    top: 0;
    text-align: center;
    box-sizing: border-box;
  }
  .content {
    position: absolute !important;
    position: relative;
    top: 68px !important;
    bottom: 0px;
    width: 100%;
    overflow: hidden;
    height: auto !important;
    left: 0px;
  }
  .main {
    height: 100%;
    min-height: 1000px;
    overflow-y: auto;
    // text-align: center;
    background: url("../../assets/enterprise/qiye.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
  }
}
</style>
